import React, { Component } from "react"
import { withStyles } from "@material-ui/core"
import * as constants from "../constants"
import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert, AlertTitle } from "@material-ui/lab"

const styles = (theme) => ({
      button: {
            margin: theme.spacing.unit,
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class TherapySlideOld extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)

            this.state = {
                  thirdpartyPriceTimeState: this.props.therapySlideOld,
                  visible: true,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
            }
      }
      componentDidMount() {
            console.log(this.props.therapySlideOld)
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeSlideoldMax = (event) => {
            var temparray = this.state.thirdpartyPriceTimeState
            temparray.therapy_slideold_max = event
            this.setState({ thirdpartyPriceTimeState: temparray })
      }
      handleChangeSlideoldMin = (event) => {
            var temparray = this.state.thirdpartyPriceTimeState
            temparray.therapy_slideold_min = event
            this.setState({ thirdpartyPriceTimeState: temparray })
      }

      handleChangeSlideoldPercent = (event) => {
            var temparray = this.state.thirdpartyPriceTimeState
            temparray.therapy_slideold_percent = event
            this.setState({ thirdpartyPriceTimeState: temparray })
      }

      modifyNewInstalmentCondition = () => {
            const { thirdpartyPriceTimeState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_therapy_slideold")
            fd.append("therapy_slideold_id", thirdpartyPriceTimeState.therapy_slideold_id)
            fd.append("therapy_slideold_percent", thirdpartyPriceTimeState.therapy_slideold_percent)
            fd.append("therapy_slideold_max", thirdpartyPriceTimeState.therapy_slideold_max)
            fd.append("therapy_slideold_min", thirdpartyPriceTimeState.therapy_slideold_min)
            xhttp.open("POST", `${constants.BASE_URL}/therapy`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteInstalmentCondition = () => {
            const { thirdpartyPriceTimeState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_therapy_slideold")
            fd.append("therapy_slideold_id", thirdpartyPriceTimeState.therapy_slideold_id)

            xhttp.open("POST", `${constants.BASE_URL}/therapy`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      render() {
            const { classes } = this.props
            const { snackMode, snackstr, showSnack, visible, thirdpartyPriceTimeState } = this.state
            if (visible) {
                  return (
                        <Grid container spacing={3}>
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid item xs={3}>
                                    <FloatingLabelInput
                                          type="number"
                                          placeholder="از تعداد"
                                          handleInputt={this.handleChangeSlideoldMin}
                                          value={thirdpartyPriceTimeState.therapy_slideold_min}
                                    />
                              </Grid>
                              <Grid item xs={3}>
                                    <FloatingLabelInput
                                          type="number"
                                          placeholder="تا تعداد"
                                          handleInputt={this.handleChangeSlideoldMax}
                                          value={thirdpartyPriceTimeState.therapy_slideold_max}
                                    />
                              </Grid>
                              <Grid item xs={3}>
                                    <FloatingLabelInput
                                          type="percent"
                                          placeholder="درصد تخفیف"
                                          handleInputt={this.handleChangeSlideoldPercent}
                                          value={thirdpartyPriceTimeState.therapy_slideold_percent}
                                    />
                              </Grid>

                              <Grid item xs={3}>
                                    <div style={{ width: "100%", textAlign: "left" }}>
                                          <Fab
                                                className={classes.small}
                                                style={{ background: "#44b700" }}
                                                aria-label="edit"
                                                onClick={this.modifyNewInstalmentCondition}
                                          >
                                                <EditIcon />
                                          </Fab>

                                          <Fab className={classes.small} color="secondary" aria-label="edit" onClick={this.deleteInstalmentCondition}>
                                                <DeleteIcon />
                                          </Fab>
                                    </div>
                              </Grid>
                              <Grid item xs={12}>
                                    <Divider />
                              </Grid>
                        </Grid>
                  )
            } else {
                  return null
            }
      }
}
export default withStyles(styles)(TherapySlideOld)
